module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAIcCAYAAAD2RY5JAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAShJREFUeNrs2EkKAkEQBEDHBUVcEBFR3JcZ///B8RMp1iHqAXGqpjK76ft+kJwGCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQ+EewSYPDNDhOg5M0OE2DszQ4T4PLNLhOg5s0uE2DuzS4T4PHNHhKg5c0eEuDjzT4TIPv8mCbBrs0+CkPduXBtvwevsq/5XsavKbBc/mbcih/l+PJIZ5t4ulrlQYX5TN2vAXEe0q8SY3Kt9F4X/aJAQQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAgEAgEAoFAIBAIBAKBQCAQCAQCgUAg8JfgV4ABANLCVFQtVP42AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/textures/highlight.png
// module id = 1626
// module chunks = 28